import React from 'react'
import { Icon } from 'antd'
import { FormattedMessage } from 'react-intl'
import Headline from '../../components/Headline'
import UploadGuideLink from '../../components/UploadGuideLink'
import PackTypeChoice from '../../components/PackTypeChoice'

function SelectPackType() {
  return (
    <div>
      <Headline
        id="Upload.PkgCreation.selectPackType.headline"
        defaultMessage="Pack Creation"
        styles={{
          margin: '42px 0px 32px 0px',
          fontFamily: 'NotoSans',
          fontSize: '34px',
          lineHeight: '36px',
          letterSpacing: 0,
        }}
      />
      <div className="select-pack-type-content">
        <UploadGuideLink
          id="Upload.PkgCreation.selectPackType.guide"
          defaultMessage="uploadGuideLink"
          styles={{ marginLeft: '10px' }}
        />
        <div className="select-pack-type-wrapper">
          <PackTypeChoice packType="PLUS" />
          <PackTypeChoice packType="BASIC" />
        </div>
        <div className="select-pack-type-caution-container">
          <div className="select-pack-type-caution-wrapper">
            <div className="select-pack-type-caution">
              <Icon
                type="check-circle"
                theme="filled"
                style={{ fontSize: '16px', marginRight: '8px' }}
              />
              <FormattedMessage
                id="Upload.PkgCreation.selectPackType.caution.1"
                defaultMessage="select pack type caution"
              />
            </div>
            <div className="select-pack-type-caution">
              <Icon
                type="check-circle"
                theme="filled"
                style={{ fontSize: '16px', marginRight: '8px' }}
              />
              <FormattedMessage
                id="Upload.PkgCreation.selectPackType.caution.2"
                defaultMessage="select pack type caution"
              />
            </div>
            <div className="select-pack-type-caution">
              <Icon
                type="check-circle"
                theme="filled"
                style={{ fontSize: '16px', marginRight: '8px' }}
              />
              <FormattedMessage
                id="Upload.PkgCreation.selectPackType.caution.3"
                defaultMessage="select pack type caution"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SelectPackType
